import React from 'react';
import Card from '../../ui/Card';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
const PilotRegionPerformance: React.FC = () => {
  const data = [{
    week: 'Week 1',
    west: 12,
    south: 8,
    north: 6,
    east: 5
  }, {
    week: 'Week 2',
    west: 18,
    south: 12,
    north: 9,
    east: 7
  }, {
    week: 'Week 3',
    west: 24,
    south: 16,
    north: 12,
    east: 10
  }, {
    week: 'Week 4',
    west: 32,
    south: 21,
    north: 15,
    east: 13
  }, {
    week: 'Week 5',
    west: 38,
    south: 25,
    north: 18,
    east: 16
  }, {
    week: 'Week 6',
    west: 45,
    south: 30,
    north: 22,
    east: 19
  }, {
    week: 'Week 7',
    west: 52,
    south: 35,
    north: 26,
    east: 22
  }, {
    week: 'Week 8',
    west: 58,
    south: 39,
    north: 29,
    east: 25
  }];
  return <Card className="p-6" data-id="element-7860">
      <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-7861">
        Pilot Region Performance Trend
      </h3>
      <p className="text-sm text-gray-600 mb-4" data-id="element-7862">
        Weekly sales volume by region (₹ Lakhs)
      </p>
      <ResponsiveContainer width="100%" height={300} data-id="element-7863">
        <LineChart data={data} data-id="element-7864">
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-7865" />
          <XAxis dataKey="week" tick={{
          fontSize: 11
        }} data-id="element-7866" />
          <YAxis tick={{
          fontSize: 12
        }} data-id="element-7867" />
          <Tooltip contentStyle={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px'
        }} formatter={(value: number) => `₹${value}L`} data-id="element-7868" />
          <Legend data-id="element-7869" />
          <Line type="monotone" dataKey="west" stroke="#3b82f6" strokeWidth={3} name="West" dot={{
          r: 4
        }} data-id="element-7870" />
          <Line type="monotone" dataKey="south" stroke="#10b981" strokeWidth={3} name="South" dot={{
          r: 4
        }} data-id="element-7871" />
          <Line type="monotone" dataKey="north" stroke="#f59e0b" strokeWidth={3} name="North" dot={{
          r: 4
        }} data-id="element-7872" />
          <Line type="monotone" dataKey="east" stroke="#8b5cf6" strokeWidth={3} name="East" dot={{
          r: 4
        }} data-id="element-7873" />
        </LineChart>
      </ResponsiveContainer>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-7874">
        <div className="grid grid-cols-4 gap-4 text-sm" data-id="element-7875">
          <div className="text-center" data-id="element-7876">
            <div className="text-gray-600" data-id="element-7877">West</div>
            <div className="text-xl font-bold text-blue-600" data-id="element-7878">₹58L</div>
            <div className="text-xs text-green-600 mt-1" data-id="element-7879">+383% growth</div>
          </div>
          <div className="text-center" data-id="element-7880">
            <div className="text-gray-600" data-id="element-7881">South</div>
            <div className="text-xl font-bold text-green-600" data-id="element-7882">₹39L</div>
            <div className="text-xs text-green-600 mt-1" data-id="element-7883">+388% growth</div>
          </div>
          <div className="text-center" data-id="element-7884">
            <div className="text-gray-600" data-id="element-7885">North</div>
            <div className="text-xl font-bold text-yellow-600" data-id="element-7886">₹29L</div>
            <div className="text-xs text-green-600 mt-1" data-id="element-7887">+383% growth</div>
          </div>
          <div className="text-center" data-id="element-7888">
            <div className="text-gray-600" data-id="element-7889">East</div>
            <div className="text-xl font-bold text-purple-600" data-id="element-7890">₹25L</div>
            <div className="text-xs text-green-600 mt-1" data-id="element-7891">+400% growth</div>
          </div>
        </div>
      </div>
    </Card>;
};
export default PilotRegionPerformance;